export default __webpack_public_path__ + "static/media/todo-img.aca42dd9.png";